<template>
  <div class="esp_page_main" :style="{padding: padding}">
    <el-scrollbar class="esp_scrollbar">
      <slot></slot>
    </el-scrollbar>
  </div>
</template>

<script>
  export default {
    name: 'EspPageMain',
    data() {
      return {}
    },
    props: {
      padding: {
        type: String,
        default: '0px 10px 10px 10px'
      }
    }
  }
</script>

<style scoped>
  .esp_page_main {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/EspPageMain.vue